module.exports = __webpack_public_path__ + "static/tesitel-79c5c3c330619a9c654e4717c156c428.jpg";